import tokens from "@alterra-mountain-company/alterra-design-system/tokens/ikonWeb";

import { BrandInterface } from "../interface";
import favicon16 from "./favicon-16x16.png";
import favicon32 from "./favicon-32x32.png";
import favicon96 from "./favicon-96x96.png";

const base = {
  enabled: {
    header: true,
    logoLockup: true,
    facebook: true,
    apple: true,
    passwordless: true,
    createAccount: true,
    forgotPassword: true,
    google: true,
    submitButtonAboveForgotPassword: false,
    errorTextBelowInput: true,
    extendedPasswordTooShortMessage: false,
    visablePasswordIndicator: false,
    showAllErrorsTogether: false,
  },
  title: "None",
  logo: "",
  resortURL: "",
  fontFamily: "proxima-nova, sans-serif",
  socialAccount: "link_social_account",
  v2Extension: "",
  favicons: {
    "16x16": favicon16,
    "32x32": favicon32,
    "96x96": favicon96,
  },
  color: {
    textColor: "",
    background: "",
    passwordTooShort: "#EB0A08",
    passwordWeak: "#EFA406",
    passwordOK: "#F7FF03",
    passwordGood: "green",
    buttonText: tokens.color.text.button.default,
    buttonDisabled: tokens.color.background.default,
    buttonDisabledText: tokens.color.text.disabled,
    errorBackground: tokens.color.background.danger.subdued,
  },
  device: {
    notMobile: "only screen and (min-width: 1023px)",
    smallMobile: "screen and (max-width: 320px)",
  },
} as BrandInterface;

export default base;
